import { render } from "./AdsItem.vue?vue&type=template&id=3f6fe3b8"
import script from "./AdsItem.vue?vue&type=script&lang=js"
export * from "./AdsItem.vue?vue&type=script&lang=js"

import "./AdsItem.vue?vue&type=style&index=0&id=3f6fe3b8&lang=scss"

import exportComponent from "C:\\Programming\\VUE\\zoopay\\zoopay\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__